// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "es6-promise/auto";
import "./polyfills";
import "lazysizes";
import isMobile from "ismobilejs";
import ifStickySupport from "./helpers/ifStickySupport";
import Vue from "vue";
import Vuebar from "vuebar";
import VueScrollTo from "vue-scrollto";
import Meta from "vue-meta";
import VueLazyload from "vue-lazyload";
import { sync } from "vuex-router-sync";
import store from "./store";
import router from "./router";
import VueResource from "vue-resource";
import App from "./components/App.vue";
import "./assets/styles/index.scss";

// TODO: change lazysizes to some vue lazy plugin ???
document.addEventListener("lazybeforeunveil", function(e) {
  const bg = e.target.getAttribute("data-bg");
  if (bg) {
    e.target.style.backgroundImage = "url(" + bg + ")";
  }
});
Vue.use(VueResource);
Vue.http.options.root = "/api/v1.0";
Vue.use(Vuebar);
Vue.use(VueScrollTo, {
  offset: -80
});
Vue.use(Meta);
Vue.use(VueLazyload, {
  loading: "",
  observer: true,
  lazyComponent: true
});

sync(store, router);

store.commit("settings/isMobile", isMobile.any);
store.commit("settings/sticky", ifStickySupport());

// disable annoying production tip in console
Vue.config.productionTip = false;

/* eslint-disable no-new */
let vue = new Vue({
  el: "#app",
  store,
  router,
  render: h => h(App)
});

export default vue;
